import Backbone from 'backbone'
import template from './datasets-filter-step.hbs'
import _ from 'lodash'

/**
 * A view which represents a step in the datasets filter picking process and is
 * responsible for rendering the form and filter controls.
 * Ex. datasets-date-filter-step2.js
 */
const DatasetsFilterStep = Backbone.View.extend({

	/** @type {Dataset} */
	model: null,

	className: 'datasets-filter-step filter-step dataset-filter',

	tagName: 'form',

	template,

	initialize: function(options) {
		this.options = options || {}
	},

	render: function() {
		this.$el.empty().append(this.template(this.context()))

		this.options.wizard && this.options.wizard.render({
			el: this.el,
			stateSaver: () => this.saveState()
		})

		return this
	},

	context: function() {
		let title = this.options.title || this.options.wizard.step2Title()
		return {
			title,
			between: this.options.filter.operator == 'between-date-time'
		}
	},

	saveState() {},

	submit: function() {
		let state = this.saveState()
		_.invoke(this.options.wizard, 'finish')
		this.trigger('done', state)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
	}
})

export default DatasetsFilterStep

DatasetsFilterStep.__filename__ = 'datasets/filters/datasets-filter-step.js'
